import { useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import { useContentStore } from '../../../providers/stores/content-store';
import { DateSelector } from '../../common/DatePicker';
import { DateService } from '../../../providers';

export type CloseDateDialogOptions = { startDate?: Date | null, endDate?: Date | null };
type CloseDialogHandler = (opts?: CloseDateDialogOptions) => void;

export type DateModalProps = {
	isOpen: boolean,
	startDate?: Date | null,
	endDate?: Date | null,
	closeDialog: CloseDialogHandler
}

export const DateModal = (props: DateModalProps) => {

	const sharedContent = useContentStore(state => state.sharedContent(state));
	const pricingContent = useContentStore(state => state.pricingContent(state));

	const [startDate, setStartDate] = useState(DateService.today());
	const [endDate, setEndDate] = useState(DateService.today());

	useEffect(() => {

		if (props.isOpen) {
			setStartDate(DateService.today());
			setEndDate(DateService.today());
		}
	}, [props.isOpen]);

	const onDialogClosed = () => {
		props.closeDialog();
	}

	const onSubmitClicked = () => {
		props.closeDialog({ startDate, endDate });
	}

	const onCancelClicked = () => {
		props.closeDialog();
	}

	return (
		<Modal
			open={props.isOpen}
			onClose={onDialogClosed}
			center
			focusTrapped={false}
			classNames={{ overlay: 'date-filter-modal-overlay', modal: 'date-filter-modal' }}>
			{props.isOpen &&
				<div id="dateDialog" className="py-4">
					<div className="row">
						<div className="col-12">
							<p>{pricingContent.dateDialogMessage}</p>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<label>{pricingContent.startDateLabel}</label>
							<div className="textWrapper">
								<DateSelector selectedDate={startDate} dateChanged={(date) => setStartDate(date)} />
							</div>
						</div>
						<div className="col">
							<label>{pricingContent.endDateLabel}</label>
							<div className="textWrapper">
								<DateSelector selectedDate={endDate} dateChanged={(date) => setEndDate(date)} />
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<div className="d-flex flex-row pt-4 pt-md-5 justify-content-end">
								<button type="button" className="btn gradientOrange" onClick={onSubmitClicked}>{sharedContent.updateButton}</button>
								<button type="button" className="btn standard ms-2" onClick={onCancelClicked}>{sharedContent.cancelButton}</button>
							</div>
						</div>
					</div>
				</div>
			}
		</Modal>
	);
};